import { useQuery } from '@apollo/client';

import HOMEPAGE_COURSES_QUERY from '../graphql/HomepageCourses.graphql';
import type {
  HomepageCourses,
  HomepageCoursesVariables,
} from '../graphql/types/HomepageCourses';

const defaultVariables = {
  first: 16,
  language: '',
};

function useCoursesQuery(
  variables: HomepageCoursesVariables = defaultVariables,
) {
  const { data, loading, error, refetch } = useQuery<
    HomepageCourses,
    HomepageCoursesVariables
  >(HOMEPAGE_COURSES_QUERY, {
    fetchPolicy: 'cache-first',
    variables,
    notifyOnNetworkStatusChange: true,
    ssr: false,
  });

  const customGetCourses = (
    category: HomepageCoursesVariables['category'],
    first = 16,
  ) =>
    refetch({
      category,
      first,
      language: '',
    });

  return { data, loading, error, getCourses: customGetCourses };
}

export default useCoursesQuery;
